/**
 * Generated by orval v7.17.0 🍺
 * Do not edit manually.
 * FieldPay API
 * FieldPay API for managing organizations, opportunities, payouts and talent management
 * OpenAPI spec version: v1
 */
import * as zod from 'zod';


export const listPayoutPoliciesResponseItem = zod.object({
  "id": zod.string().uuid(),
  "name": zod.string(),
  "releaseTiming": zod.object({
  "recurrence": zod.object({
  "frequency": zod.enum(['Daily', 'Weekly', 'Monthly']),
  "interval": zod.number(),
  "startDate": zod.string().date(),
  "releaseTimeOfDay": zod.enum(['BeginningOfDay', 'EndOfDay']),
  "daysOfWeek": zod.array(zod.enum(['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'])),
  "daysOfMonth": zod.array(zod.number())
}).optional(),
  "netTerms": zod.object({
  "days": zod.number(),
  "releaseTimeOfDay": zod.enum(['BeginningOfDay', 'EndOfDay'])
}).optional()
}),
  "earlyDisbursement": zod.object({
  "feeRate": zod.number(),
  "netTerms": zod.object({
  "days": zod.number()
}).optional()
}).optional(),
  "maximumFeeRate": zod.number(),
  "isSystem": zod.boolean(),
  "isDefault": zod.boolean(),
  "modifiedDate": zod.string().datetime({}),
  "modifiedByUserId": zod.string().uuid().nullish()
})
export const listPayoutPoliciesResponse = zod.array(listPayoutPoliciesResponseItem)

/**
 * **Required Permission(s):** ORG_UPDATE
 */
export const createPayoutPolicyBody = zod.object({
  "name": zod.string(),
  "releaseTiming": zod.object({
  "recurrence": zod.object({
  "frequency": zod.enum(['Daily', 'Weekly', 'Monthly']),
  "interval": zod.number(),
  "startDate": zod.string().date(),
  "releaseTimeOfDay": zod.enum(['BeginningOfDay', 'EndOfDay']),
  "daysOfWeek": zod.array(zod.enum(['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'])),
  "daysOfMonth": zod.array(zod.number())
}).optional(),
  "netTerms": zod.object({
  "days": zod.number(),
  "releaseTimeOfDay": zod.enum(['BeginningOfDay', 'EndOfDay'])
}).optional()
}),
  "earlyDisbursement": zod.object({
  "feeRate": zod.number(),
  "netTerms": zod.object({
  "days": zod.number()
}).optional()
}).optional()
})

export const getPayoutPolicyParams = zod.object({
  "id": zod.string().uuid()
})

export const getPayoutPolicyResponse = zod.object({
  "id": zod.string().uuid(),
  "name": zod.string(),
  "releaseTiming": zod.object({
  "recurrence": zod.object({
  "frequency": zod.enum(['Daily', 'Weekly', 'Monthly']),
  "interval": zod.number(),
  "startDate": zod.string().date(),
  "releaseTimeOfDay": zod.enum(['BeginningOfDay', 'EndOfDay']),
  "daysOfWeek": zod.array(zod.enum(['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'])),
  "daysOfMonth": zod.array(zod.number())
}).optional(),
  "netTerms": zod.object({
  "days": zod.number(),
  "releaseTimeOfDay": zod.enum(['BeginningOfDay', 'EndOfDay'])
}).optional()
}),
  "earlyDisbursement": zod.object({
  "feeRate": zod.number(),
  "netTerms": zod.object({
  "days": zod.number()
}).optional()
}).optional(),
  "maximumFeeRate": zod.number(),
  "isSystem": zod.boolean(),
  "isDefault": zod.boolean(),
  "modifiedDate": zod.string().datetime({}),
  "modifiedByUserId": zod.string().uuid().nullish()
})

/**
 * **Required Permission(s):** ORG_UPDATE
 */
export const updatePayoutPolicyParams = zod.object({
  "id": zod.string().uuid()
})

export const updatePayoutPolicyBody = zod.object({
  "name": zod.string(),
  "releaseTiming": zod.object({
  "recurrence": zod.object({
  "frequency": zod.enum(['Daily', 'Weekly', 'Monthly']),
  "interval": zod.number(),
  "startDate": zod.string().date(),
  "releaseTimeOfDay": zod.enum(['BeginningOfDay', 'EndOfDay']),
  "daysOfWeek": zod.array(zod.enum(['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'])),
  "daysOfMonth": zod.array(zod.number())
}).optional(),
  "netTerms": zod.object({
  "days": zod.number(),
  "releaseTimeOfDay": zod.enum(['BeginningOfDay', 'EndOfDay'])
}).optional()
}),
  "earlyDisbursement": zod.object({
  "feeRate": zod.number(),
  "netTerms": zod.object({
  "days": zod.number()
}).optional()
}).optional()
})

export const updatePayoutPolicyResponse = zod.object({
  "id": zod.string().uuid(),
  "name": zod.string(),
  "releaseTiming": zod.object({
  "recurrence": zod.object({
  "frequency": zod.enum(['Daily', 'Weekly', 'Monthly']),
  "interval": zod.number(),
  "startDate": zod.string().date(),
  "releaseTimeOfDay": zod.enum(['BeginningOfDay', 'EndOfDay']),
  "daysOfWeek": zod.array(zod.enum(['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'])),
  "daysOfMonth": zod.array(zod.number())
}).optional(),
  "netTerms": zod.object({
  "days": zod.number(),
  "releaseTimeOfDay": zod.enum(['BeginningOfDay', 'EndOfDay'])
}).optional()
}),
  "earlyDisbursement": zod.object({
  "feeRate": zod.number(),
  "netTerms": zod.object({
  "days": zod.number()
}).optional()
}).optional(),
  "maximumFeeRate": zod.number(),
  "isSystem": zod.boolean(),
  "isDefault": zod.boolean(),
  "modifiedDate": zod.string().datetime({}),
  "modifiedByUserId": zod.string().uuid().nullish()
})

/**
 * **Required Permission(s):** ORG_UPDATE
 */
export const deletePayoutPolicyParams = zod.object({
  "id": zod.string().uuid()
})

/**
 * **Required Permission(s):** ORG_UPDATE
 */
export const markPayoutPolicyDefaultParams = zod.object({
  "id": zod.string().uuid()
})

export const markPayoutPolicyDefaultResponse = zod.object({
  "id": zod.string().uuid(),
  "name": zod.string(),
  "releaseTiming": zod.object({
  "recurrence": zod.object({
  "frequency": zod.enum(['Daily', 'Weekly', 'Monthly']),
  "interval": zod.number(),
  "startDate": zod.string().date(),
  "releaseTimeOfDay": zod.enum(['BeginningOfDay', 'EndOfDay']),
  "daysOfWeek": zod.array(zod.enum(['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'])),
  "daysOfMonth": zod.array(zod.number())
}).optional(),
  "netTerms": zod.object({
  "days": zod.number(),
  "releaseTimeOfDay": zod.enum(['BeginningOfDay', 'EndOfDay'])
}).optional()
}),
  "earlyDisbursement": zod.object({
  "feeRate": zod.number(),
  "netTerms": zod.object({
  "days": zod.number()
}).optional()
}).optional(),
  "maximumFeeRate": zod.number(),
  "isSystem": zod.boolean(),
  "isDefault": zod.boolean(),
  "modifiedDate": zod.string().datetime({}),
  "modifiedByUserId": zod.string().uuid().nullish()
})

export const listPayeesOnLegacyTermsParams = zod.object({
  "id": zod.string().uuid()
})

export const listPayeesOnLegacyTermsResponseItem = zod.object({
  "payeeType": zod.enum(['User', 'Organization']),
  "rosterMemberId": zod.string().uuid(),
  "displayName": zod.string(),
  "releaseTiming": zod.object({
  "recurrence": zod.object({
  "frequency": zod.enum(['Daily', 'Weekly', 'Monthly']),
  "interval": zod.number(),
  "startDate": zod.string().date(),
  "releaseTimeOfDay": zod.enum(['BeginningOfDay', 'EndOfDay']),
  "daysOfWeek": zod.array(zod.enum(['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'])),
  "daysOfMonth": zod.array(zod.number())
}).optional(),
  "netTerms": zod.object({
  "days": zod.number(),
  "releaseTimeOfDay": zod.enum(['BeginningOfDay', 'EndOfDay'])
}).optional()
}),
  "earlyDisbursement": zod.object({
  "feeRate": zod.number(),
  "netTerms": zod.object({
  "days": zod.number()
}).optional()
}).optional()
})
export const listPayeesOnLegacyTermsResponse = zod.array(listPayeesOnLegacyTermsResponseItem)

/**
 * **Required Permission(s):** ORG_PAYEE_ASSIGN_PAYOUT_POLICY
 */
export const movePayeesToCurrentTermsParams = zod.object({
  "id": zod.string().uuid()
})

export const movePayeesToCurrentTermsBody = zod.object({
  "rosterMemberIds": zod.array(zod.string().uuid())
})

export const movePayeesToCurrentTermsResponseItem = zod.object({
  "payeeType": zod.enum(['User', 'Organization']),
  "rosterMemberId": zod.string().uuid(),
  "displayName": zod.string(),
  "releaseTiming": zod.object({
  "recurrence": zod.object({
  "frequency": zod.enum(['Daily', 'Weekly', 'Monthly']),
  "interval": zod.number(),
  "startDate": zod.string().date(),
  "releaseTimeOfDay": zod.enum(['BeginningOfDay', 'EndOfDay']),
  "daysOfWeek": zod.array(zod.enum(['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'])),
  "daysOfMonth": zod.array(zod.number())
}).optional(),
  "netTerms": zod.object({
  "days": zod.number(),
  "releaseTimeOfDay": zod.enum(['BeginningOfDay', 'EndOfDay'])
}).optional()
}),
  "earlyDisbursement": zod.object({
  "feeRate": zod.number(),
  "netTerms": zod.object({
  "days": zod.number()
}).optional()
}).optional()
})
export const movePayeesToCurrentTermsResponse = zod.array(movePayeesToCurrentTermsResponseItem)

/**
 * **Required Permission(s):** ORG_UPDATE
 */
export const previewReleaseDatesBody = zod.object({
  "releaseTiming": zod.object({
  "recurrence": zod.object({
  "frequency": zod.enum(['Daily', 'Weekly', 'Monthly']),
  "interval": zod.number(),
  "startDate": zod.string().date(),
  "releaseTimeOfDay": zod.enum(['BeginningOfDay', 'EndOfDay']),
  "daysOfWeek": zod.array(zod.enum(['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'])),
  "daysOfMonth": zod.array(zod.number())
}).optional(),
  "netTerms": zod.object({
  "days": zod.number(),
  "releaseTimeOfDay": zod.enum(['BeginningOfDay', 'EndOfDay'])
}).optional()
}),
  "from": zod.string().date(),
  "to": zod.string().date()
})

export const previewReleaseDatesResponse = zod.object({
  "releaseDates": zod.array(zod.string().datetime({}))
})

